
import { defineComponent, ref } from 'vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import { useAgreementModule } from '@/modules/agreements'
import { AgreementsRouteNames } from '@/router/routes-names'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
    name: 'agreement-cancel-agreement',
    props: {
        id: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const router = useRouter()
        const route = useRoute()
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
        const { submitForm, createOnSuccess } = useFormModule()
        const { cancelAgreement, getAgreement } = useAgreementModule()

        const form = ref<QForm>()
        const immediatelyCancelledModel = ref(false)

        const sendRequest = async () => cancelAgreement(props.id, immediatelyCancelledModel.value)

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Agreement cancelled')
        )
            .then(() => getAgreement(props.id))
            .then(onDialogOK)

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            immediatelyCancelledModel,
            onSubmit,
            form
        }
    }
})
